import expenseService from '../../services/expense'

const state = {
    loading: false,
    errors: null,
    expenses: [],
    exp_ledgeraccs:[]
}

const actions = {
    getAll({ commit }) {
        commit('EXPENSE_LOADING', true)
        expenseService.getAll().then(
            response => {

                commit('LOAD_EXPENSES', response.data)
                commit('EXPENSE_LOADING', false)
            },
            error => {
                commit('EXPENSE_FAILURE', error)
                commit('EXPENSE_LOADING', false)
            }
        )
    },
    add({ commit }, data) {
        commit('EXPENSE_LOADING', true)
        commit('EXPENSE_FAILURE', null)
        expenseService.add(data).then(
            response => {
                data.id = response.data.id
                data.recorded_by = response.data.recorded_by
                data.ledgeracc = response.data.ledgeracc
                commit('ADD_EXPENSE', data)
                commit('EXPENSE_LOADING', false)
            },
            error => {
                commit('EXPENSE_FAILURE', error)
                commit('EXPENSE_LOADING', false)
            }
        )
    },
    update({ commit }, data) {
        commit('EXPENSE_LOADING', true)
        commit('EXPENSE_FAILURE', null)
        expenseService.update(data.expense)
            .then(
                response => {

                    data.expense.ledgeracc = response.data.ledgeracc

                    //console.log(data)
                    commit('UPDATE_EXPENSE', data)
                    commit('EXPENSE_LOADING', false)
                },
                error => {
                    commit('EXPENSE_FAILURE', error)
                    commit('EXPENSE_LOADING', false)
                }
            )


    },
    delete({ commit }, data) {
        commit('EXPENSE_LOADING', true)
        commit('EXPENSE_FAILURE', null)
        expenseService.delete(data.expense.id)
            .then(
                response => {

                    commit('DELETE_EXPENSE', data)
                    commit('EXPENSE_LOADING', false)
                },
                error => {
                    commit('EXPENSE_FAILURE', error)
                    commit('EXPENSE_LOADING', false)
                }
            )
    }
}

const mutations = {
    ADD_EXPENSE(state, payload) {
        state.expenses.unshift(payload);
    },
    LOAD_EXPENSES(state, payload) {
        state.expenses = payload.expenses
        state.exp_ledgeraccs = payload.ledgeraccs
    },
    UPDATE_EXPENSE(state, payload) {
        Object.assign(state.expenses[payload.index], payload.expense);
    },
    DELETE_EXPENSE(state, payload) {
        state.expenses.splice(payload.index, 1)
    },
    EXPENSE_FAILURE(state, payload) {
        state.errors = payload
    },

    EXPENSE_LOADING(state, payload) {
        state.loading = payload
    },
}


const getters = {
    EXPENSES: state => {
        return state.expenses
    },

    EXPENSE_LEDGERACCS: state => {
      return state.exp_ledgeraccs
  },

    EXPENSE_ERROR: state => {
        return state.errors
    },

    EXPENSE_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
